import { sessaoFetchLoading, sessaoFetch } from '@/service/fetch'

export async function getFilas (pedidoId) {
  return sessaoFetchLoading('consig', `/pedidos/StatusFila/${pedidoId}`)
}

export async function getFilasSemLoad (pedidoId) {
  return sessaoFetch('consig', `/pedidos/StatusFila/${pedidoId}`)
}
export async function iniciaProcesso (pedidoId) {
  return sessaoFetchLoading('consig', `/pedidos/IniciarFila/${pedidoId}`, 'PUT')
}

export async function cancelaTodasFilas (pedidoId) {
  return sessaoFetchLoading('consig', `/pedidos/CancelarFila/${pedidoId}`)
}

export async function reiniciaFila (fila) {
  return sessaoFetchLoading('consig', `/queue/Reiniciar/${fila.queueId}`)
}

export async function cancelaFila (fila) {
  return sessaoFetchLoading('consig', `/queue/Parar/${fila.queueId}`)
}

export async function getFilaProcessada (pedidoId) {
  return sessaoFetch('consig', `/pedidos/FilaProcessada/${pedidoId}`)
}



// WEBPACK FOOTER //
// ./src/api/sincBanco.js